import { combineReducers } from '@reduxjs/toolkit';

import LoginReducer from './auth/login/reducer';
import AccountReducer from './auth/register/reducer';
import ProfileReducer from './auth/profile/reducer';
import ForgetPasswordReducer from './auth/forgetpwd/reducer';
import ProjectsReducer from './project/reducer';
import UsersReducer from './users/reducer';
import VehiclesReducer from './vehicles/reducer';
import SitesReducer from './sites/reducer';
import StatisticsReducer from './statistics/reducer';
import CompanyReducer from './company/reducer';
import PolesReducer from './poles/reducer';

const rootReducer = combineReducers({
    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgetPasswordReducer,
    Projects: ProjectsReducer,
    Users: UsersReducer,
    Vehicles: VehiclesReducer,
    Sites: SitesReducer,
    Statistics: StatisticsReducer,
    Company: CompanyReducer,
    Poles: PolesReducer,
});

export default rootReducer;
